import { PRIORITIES } from '@/core/constants/installation-priorities.constant'
import { apiClient } from '@/shared/services/http/http.service'

export const priority = PRIORITIES.HTTP

export function install({ app }) {
  const defaultApiClient = (service) => {
    if (!service) {
      throw new Error('Service parameter is required')
    }
    return apiClient(service)
  }

  app.config.globalProperties.$api = apiClient
  app.provide('apiClient', defaultApiClient)
}
